export function wireExtendListeners(segment, ctx) {
    const { $uiEvents } = ctx

    $uiEvents.$on('warrantyOfferMade', (product) => {
        segment.track('Warranty: Offer Made', segment.getCartProduct(product))
    })

    $uiEvents.$on('warrantyDeclined', (product) => {
        segment.track('Warranty: Declined', segment.getCartProduct(product))
    })

    $uiEvents.$on('addWarranty', (product) => {
        segment.track('Warranty: Added', segment.getCartProduct(product))
    })

    $uiEvents.$on('removeWarranty', (product) => {
        segment.track('Warranty: Removed', segment.getCartProduct(product))
    })
}
